import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { Link } from 'foundations-components/transitional/components/Link';
import { getLineItemRecurringFrequencyBySubtotal } from 'payments-checkout-lib/utils/recurring';
import { RELATIVE_START_DATE } from 'payments-checkout-lib/constants/LineItems';
import { usePaymentFormContext } from '../../context/PaymentFormContext';
import { useSubtotals } from '../../context/SubtotalsProvider';
import FormattedPrice from '../Utilities/FormattedPrice';
import { jsx as _jsx } from "react/jsx-runtime";
const getMultiSubscriptionMessage = termsOfServiceUrl => {
  return termsOfServiceUrl ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "payments.zeroCheckoutTermsOfService.multiSubscriptionWithLink_jsx",
    options: {
      href: termsOfServiceUrl
    },
    elements: {
      Link
    }
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "payments.zeroCheckoutTermsOfService.multiSubscription"
  });
};
const getSingleSubscriptionMessage = ({
  termsOfServiceUrl,
  recurringSubtotals,
  currencyCode
}) => {
  const recurringSubtotal = recurringSubtotals[0];
  const {
    subtotal,
    recurringBillingTerms: {
      intervalUnit,
      intervalLength,
      initialPayment: {
        type,
        futureStartDate,
        relativeDelay
      },
      numPayments
    }
  } = recurringSubtotal;
  const delayLength = relativeDelay && relativeDelay.delayLength;
  const delayUnit = relativeDelay && relativeDelay.delayUnit;
  const futureStartType = type === RELATIVE_START_DATE ? 'relativeDelay' : 'futureStartDate';
  const hasNumPayments = numPayments ? 'AndNumPayments' : '';
  const message = termsOfServiceUrl ? `payments.zeroCheckoutTermsOfService.${futureStartType}WithLink${hasNumPayments}_jsx` : `payments.zeroCheckoutTermsOfService.${futureStartType}${hasNumPayments}_jsx`;
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: message,
    options: {
      href: termsOfServiceUrl,
      priceProps: {
        currencyCode,
        price: subtotal,
        frequency: getLineItemRecurringFrequencyBySubtotal(intervalUnit, intervalLength),
        simplify: false
      },
      numPayments,
      delayLength,
      delayUnit: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `payments.relativeStartDateDelayUnits.${delayUnit}`,
        options: {
          count: delayLength
        }
      }),
      formattedDate: /*#__PURE__*/_jsx(FormattedDateTime, {
        value: Number(futureStartDate),
        format: "L",
        type: "utc"
      })
    },
    elements: {
      FormattedPrice,
      Link
    }
  });
};
const getMessage = ({
  recurringSubtotals,
  currencyCode,
  termsOfServiceUrl
}) => {
  const isMultiSubscription = recurringSubtotals.length > 1;
  const isAllOptionalLineItems = recurringSubtotals.length === 0;
  if (isMultiSubscription || isAllOptionalLineItems) {
    return getMultiSubscriptionMessage(termsOfServiceUrl);
  } else {
    return getSingleSubscriptionMessage({
      termsOfServiceUrl,
      recurringSubtotals,
      currencyCode
    });
  }
};
const ZeroCheckoutTermsOfService = () => {
  var _checkoutSession$poli;
  const {
    checkoutSession: checkoutSessionMap
  } = usePaymentFormContext();
  const checkoutSession = checkoutSessionMap.toJS();
  const {
    recurringSubtotals = [],
    loading: subtotalsLoading
  } = useSubtotals();
  if (subtotalsLoading) {
    return null;
  }
  const currencyCode = checkoutSession.currencyCode;
  const termsOfServiceUrl = ((_checkoutSession$poli = checkoutSession.policySettingsData) === null || _checkoutSession$poli === void 0 ? void 0 : _checkoutSession$poli.termsOfServiceUrl) || '';
  return getMessage({
    recurringSubtotals,
    currencyCode,
    termsOfServiceUrl
  });
};
export default ZeroCheckoutTermsOfService;